import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalDataServiceService {

  constructor() { }

  getHeaders() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    });

    const token = this.getToken();
    if (token) {
      if (token.startsWith('Bearer ')) {
        headers = headers.set('Authorization', token);
      } else {
        headers = headers.set('Authorization', 'Bearer ' + token);
      }
    }

    return headers;
  }



  getToken() {
    return localStorage.getItem("authToken");
  }
}